import { Input, InputProps as InputLibProps } from '@ui-kitten/components';
import { CommonFieldProps } from '../commonFieldProps';

export type InputProps = InputLibProps &
	CommonFieldProps & {
		gutter?: boolean;
		fullWidth?: boolean;
		optional?: boolean;
		interactive?: boolean;
	};

export type InputType = Input;
